export class User {
  constructor({
    id,
    email,
    firstName,
    lastName,
    phoneNumber,
    countryCode,
    createdAt,
    updatedAt,
    metadata,
    favoriteRestaurants,
    favoriteDishes,
    profilePictureUrl,
    referralCode
  } = {}) {
    this.id = id;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.phoneNumber = phoneNumber;
    this.countryCode = countryCode;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.profilePictureUrl = profilePictureUrl;
    this.referralCode = referralCode;
    this.metadata = metadata || {};
    this.favoriteRestaurants = favoriteRestaurants || [];
    this.favoriteDishes = favoriteDishes || [];

    Object.freeze(this); // immutable
  }
}
